// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4183":"c1ddd618","5134":"6dec7cb6"}[chunkId] + ".chunk.css";
};